import { useState } from "react";

import { useApplication } from "../ApplicationContext";
import {
  NameClaim,
  PreviousNameEntry,
  nameMatchesApplicant,
} from "../utils/name-matching";

interface NameMatchGate {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  gateSubmit: (submit: () => void) => void;
}

export function useNameMatchGate(
  candidate: NameClaim | undefined
): NameMatchGate {
  const { data } = useApplication();
  const legalName = (data?.name ?? {}) as NameClaim;
  const previousNames = (data?.previous_names ?? []) as PreviousNameEntry[];
  const [showModal, setShowModal] = useState(false);

  const gateSubmit = (submit: () => void) => {
    if (
      !candidate ||
      !nameMatchesApplicant(candidate, legalName, previousNames)
    ) {
      setShowModal(true);
      return;
    }
    submit();
  };

  return { showModal, setShowModal, gateSubmit };
}
